/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationCredentialModelDto } from '../../models/integration-credential-model-dto';
import { UpsertIntegrationDto } from '../../models/upsert-integration-dto';

export interface IntegrationsControllerUpsertIntegration$Params {
  provider: string;
      body: UpsertIntegrationDto
}

export function integrationsControllerUpsertIntegration(http: HttpClient, rootUrl: string, params: IntegrationsControllerUpsertIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationCredentialModelDto>> {
  const rb = new RequestBuilder(rootUrl, integrationsControllerUpsertIntegration.PATH, 'put');
  if (params) {
    rb.path('provider', params.provider, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationCredentialModelDto>;
    })
  );
}

integrationsControllerUpsertIntegration.PATH = '/integrations/{provider}';
